import React from "react";
import "./uiPending.scss";

export type StatTileTone = "neutral" | "primary" | "accent" | "success" | "warning" | "danger" | "info";

interface StatTileProps {
  label: React.ReactNode;
  value: React.ReactNode;
  hint?: React.ReactNode;
  tone?: StatTileTone;
  /** Optional 0–100 meter under the value (e.g. an average score). */
  progress?: number | null;
  align?: "center" | "start";
  className?: string;
}

/** Pending src/ui component: a KPI tile — big number, label, optional meter and one-line hint. */
const StatTile: React.FC<StatTileProps> = ({ label, value, hint, tone = "neutral", progress, align = "center", className }) => (
  <div className={`sa-stat sa-stat--${tone} sa-stat--${align}${className ? ` ${className}` : ""}`}>
    {align === "start" && <div className="sa-stat__label">{label}</div>}
    <div className="sa-stat__value ds-num">{value}</div>
    {align === "center" && <div className="sa-stat__label">{label}</div>}
    {progress !== undefined && (
      <div className="sa-stat__meter" aria-hidden>
        {/* Width is the data value itself, clamped to 0–100. */}
        <span style={{ width: `${Math.max(0, Math.min(100, progress ?? 0))}%` }} />
      </div>
    )}
    {hint && <div className="sa-stat__hint">{hint}</div>}
  </div>
);

export default StatTile;
